import { Controller } from "@hotwired/stimulus"
import getCsrfToken from "../utils/csrf";
import _ from 'underscore';

export default class extends Controller {
    static targets = [
        "propertySource",
        "locationSource",
        "placesAddress",
        "building",
        "locationType",
        "spaceUsageType",
        "spaceSize",
        "description",
        "spaceFeatures",
        "insideSpace",
        "outsideSpace",
        "rent",
        "period",
        "minimumRent",
        "unit",
        "spaceSection",
        "featuresSection",
        "priceAvailabilitySection",
        "settingsSection",
        "conversionVisibilitySection"
    ]

    static values = {
        updateUrl: String,
    }

    connect() {}

    submit() {}

    onChange() {
        this.validateSpaceSection()
        this.validateFeaturesSection()
        this.validatePriceSection()
        this.validateSettingsSection()
    }

    validateSpaceSection() {
        const propertyInputElement = this.propertySourceTarget.querySelector('input');
        const locationInputElement = this.locationSourceTarget.querySelector('input');

        const targets = [
            ...(locationInputElement.checked ? [{
                target: this.placesAddressTarget,
                valid: this.isFilled(this.placesAddressTarget)
            }] : []),

            ...(propertyInputElement.checked ? [{
                target: this.buildingTarget,
                valid: this.isFilled(this.buildingTarget)
            }] : []),

            { target: this.locationTypeTarget, valid: this.isFilled(this.locationTypeTarget) },
            { target: this.spaceSizeTarget, valid: this.isFilled(this.spaceSizeTarget) },
            { target: this.spaceUsageTypeTarget, valid: this.isFilled(this.spaceUsageTypeTarget) },
            { target: this.descriptionTarget, valid: this.isFilled(this.descriptionTarget) },
        ];

        _.debounce(() => this.updateSectionHighlight(targets, this.spaceSectionTarget), 1000)();
    }

    validateFeaturesSection() {
        const targets = [
            { target: this.spaceFeaturesTarget, valid: this.isFilled(this.spaceFeaturesTarget) },
            { target: this.insideSpaceTarget, valid: this.isFilled(this.insideSpaceTarget) },
            { target: this.spaceSectionTarget, valid: this.isFilled(this.outsideSpaceTarget) },
        ];

        _.debounce(() => this.updateSectionHighlight(targets, this.featuresSectionTarget), 500)();
    }

    validatePriceSection() {
        const rentInputElement = this.rentTarget.querySelector('input'); // Autonumeric conflict, cant use  input directly
        const targets = [
            { target: rentInputElement, valid: this.isFilled(rentInputElement) },
            { target: this.periodTarget, valid: this.isFilled(this.periodTarget) },
            { target: this.minimumRentTarget, valid: this.isFilled(this.minimumRentTarget) },
        ];

        _.debounce(() => this.updateSectionHighlight(targets, this.priceAvailabilitySectionTarget), 500)();
    }

    validateSettingsSection() {
        const targets = [
            { target: this.unitTarget, valid: this.isFilled(this.unitTarget) }
        ];

        _.debounce(() => this.updateSectionHighlight(targets, this.settingsSectionTarget), 500)();
    }

    updateSectionHighlight(targets, sectionTarget) {
        const allValid = targets.every(item => item.valid);

        if (allValid) {
            sectionTarget.classList.add("bg-primary-green-brand");
            sectionTarget.classList.remove("bg-gray-300");
        } else {
            sectionTarget.classList.add("bg-gray-300");
            sectionTarget.classList.remove("bg-primary-green-brand");
        }
    }

    isFilled(input) {
        return input.value.trim() !== '';
    }

    toggleLocationSource(event) {
        const propertyInputElement = this.propertySourceTarget.querySelector('input');
        const locationInputElement = this.locationSourceTarget.querySelector('input');

        if (event.currentTarget === this.propertySourceTarget) {
            propertyInputElement.checked = true;
            locationInputElement.checked = false;
            this.propertySourceTarget.classList.add('border-green-brand');
            this.locationSourceTarget.classList.remove('border-green-brand');
        }

        if (event.currentTarget === this.locationSourceTarget) {
            locationInputElement.checked = true;
            propertyInputElement.checked = false;
            this.propertySourceTarget.classList.remove('border-green-brand');
            this.locationSourceTarget.classList.add('border-green-brand');
        }
    }

    handleFetch(url, method, body = {}) {
        fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/html",
                "X-CSRF-Token": getCsrfToken()
            },
            body: JSON.stringify(body)
        })
            .then(response => {
                const redirectTo = response.headers.get('redirect-to');
                if (redirectTo) {
                    window.location.href = redirectTo;
                    return;
                }

                if ([400, 500].includes(response.status)) return;

                const renderTarget = response.headers.get('render-target');

                return response.text().then(html => {
                    Turbolinks.clearCache();

                    if (renderTarget) {
                        const dstEl = document.querySelector(renderTarget);
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = html;

                        const srcEl = tempDiv.querySelector(renderTarget);

                        if (srcEl && dstEl) {
                            dstEl.innerHTML = srcEl.innerHTML;
                        }
                    } else {
                        document.body.innerHTML = html;
                    }

                    Turbolinks.dispatch("turbolinks:load");
                });
            })
            .catch(error => {
                console.error("Fetch failed", error);
            });
    }

    submit_listing(event) {
        event.preventDefault();
        this.handleFetch(this.updateUrlValue, "PUT", {
            render_target: '#listing_edit',
            v2_edit: true,
            listing: { current_partial: "listing_publish" }
        });
    }
}
